
import { EFilter } from '@/helpers/enums'

export default {
  name: 'TextSearch',

  props: {
    dense: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      inputText: '',
      recentSearches: [],
      showMenu: false
    }
  },

  fetch() {
    this.applyFilter(this.$route.query[EFilter.TEXT])
  },

  computed: {
    selectedSimpleQuery: {
      get() {
        return this.$route.query[EFilter.TEXT] || null
      },
      async set(val) {
        this.$emit('before-update')
        const bool = Boolean(val)

        if (bool) {
          await this.$updateQuery(this.$route.query, {
            [EFilter.TEXT]: encodeURIComponent(val)
          })
        } else {
          await this.$cleanQuery(this.$route.query, EFilter.TEXT)
        }

        this.$emit('updated')
      }
    },
    inputTextEmpty() {
      return !this.inputText?.trim()
    }
  },

  watch: {
    [`$route.query.${EFilter.TEXT}`](data) {
      if (!data) {
        this.inputText = ''
      }
    },

    inputText(val) {
      if (!val) {
        this.clearFilter()
      }
    }
  },

  mounted() {
    try {
      const storedSearches = localStorage.getItem('recentSearches')
      this.recentSearches = storedSearches ? JSON.parse(storedSearches) : []
    } catch (e) {
      console.warn('LocalStorage is not available', e)
      this.recentSearches = []
    }
  },

  methods: {
    applyFilter(data) {
      if (data) {
        this.inputText = decodeURIComponent(data)
      }
    },

    fillSelected(val) {
      if (val) {
        this.selectedSimpleQuery = val
        this.saveSearch(val)
        this.showMenu = false
      } else {
        this.inputText = ''
      }
    },

    clearFilter() {
      this.selectedSimpleQuery = null
      this.inputText = ''
    },

    saveSearch(val) {
      if (val && !this.recentSearches.includes(val)) {
        this.recentSearches.unshift(val)
        if (this.recentSearches.length > 5) this.recentSearches.pop()
        localStorage.setItem('recentSearches', JSON.stringify(this.recentSearches))
      }
    },

    selectSearch(item) {
      this.inputText = item
      this.fillSelected(item)
      this.showMenu = false
    }
  }
}
